
import { useState } from 'react';
import styles from './index.less'


const PatientConsultation = (props: any) => {
    
    const [idnexID, setIdnexID] = useState<any>(3);
    const {departData , pageId , 
        contentDiagData , icon_right, 
        evaluate5
    } = props;
  

    const textParagraphContent = (data: any) => {
        return (
          data &&
          data.length > 0 &&
          data
            .map((val: any) => {
              if (
                val?.body?.type == "text" &&
                val?.from?.app == "jd.doctor" &&
                val?.body?.content
              ) {
                return val?.body?.content;
              }
            })
            .filter((itme: any) => {
              return itme && itme.trim();
            })
            .join("")
        );
      };
    return (
            <div className={styles.pconsultationList}>
              <div className={styles.pconsultationListTit}>
                <div>{departData?.secondDepartName}患友问诊</div>
              </div>
     
              {contentDiagData && contentDiagData.length > 0 ? (
                <ul>
                  {contentDiagData.map((itme: any, index: any) => {
                     if (index < idnexID) {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          window.open(
                            window.location.origin +
                              "/qa" +
                              "/" +
                              itme?.contentDiags[0]?.diagId
                          );
                        }}
                      >
                        <div className={styles.consultationNo}>
                          {itme?.contentParagraphs.map(
                            (v: any, idnex1: any) => {
                              try {
                                let text: any = textParagraphContent(
                                  JSON.parse(v.paragraphContent)
                                );
                                return (
                                  <div key={idnex1}>
                                    {(itme?.contentName + "|" + text.substring(0, 100))}
                                  </div>
                                );
                              } catch (error) {
                                console.log(error, 'error')
                              }
                            }
                          )}
                        </div>
                        <div className={styles.pconsultationListTop}>
                          <a
                            className={styles.pconsultationListTopText}
                            data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                          >
                            {itme?.contentName}
                          </a>
                          <div className={styles.pconsultationListTopInfo}>
                            <span
                              data-a-href={
                                "/qa/" + itme?.contentDiags[0]?.diagId
                              }
                              data-a-nofollow="true"
                            >
                              点击查看
                            </span>
                            <img src={icon_right} alt="" />
                          </div>
                        </div>
                        <div className={styles.pconsultationListBon}>
                          <div className={styles.pconsultationListBonLeft}>
                            <div
                              className={styles.pconsultationListBonLeftText1}
                            >
                              <h3>总交流次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount +
                                  itme?.contentDiags[0]?.patientExchangeCount ||
                                  0}
                              </h5>
                            </div>
                            <div
                              className={styles.pconsultationListBonLeftLine}
                            />
                            <div
                              className={styles.pconsultationListBonLeftText2}
                            >
                              <h3>医生回复次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount ||
                                  0}
                              </h5>
                            </div>
                          </div>
                          <div className={styles.pconsultationListBonInfo}>
                            <span>患者：</span>
                            <h4>
                              {itme?.contentDiags[0]?.patientSex == 1
                                ? "男 "
                                : "女 "}
                              {itme?.contentDiags[0]?.patientAge || 0}
                            </h4>
                          </div>
                        </div>
                      </li>
                    )
                    };
                  })}
                </ul>
              ) : (
                <div className={styles.pconsultationListNo}>暂无问诊记录</div>
              )}
               {contentDiagData && contentDiagData.length > 0 && (
                <ul className={styles.seourl}> 
                  {contentDiagData.map((itme: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          window.open(
                            window.location.origin +
                              "/qa" +
                              "/" +
                              itme?.contentDiags[0]?.diagId
                          );
                        }}
                      >
                        <div className={styles.consultationNo}>
                          {itme?.contentParagraphs.map(
                            (v: any, idnex1: any) => {
                              try {
                                let text: any = textParagraphContent(
                                  JSON.parse(v.paragraphContent)
                                );
                                return (
                                  <div key={idnex1}>
                                    {(itme?.contentName + text).substring(0, 100)}
                                  </div>
                                );
                              } catch (error) {
                                console.log(error, 'error')
                              }
                            }
                          )}
                        </div>
                        <div className={styles.pconsultationListTop}>
                          <div
                            className={styles.pconsultationListTopText}
                            data-a-href={"/qa/" + itme?.contentDiags[0]?.diagId}
                          >
                            {itme?.contentName}
                          </div>
                          <div className={styles.pconsultationListTopInfo}>
                            <span
                              data-a-href={
                                "/qa/" + itme?.contentDiags[0]?.diagId
                              }
                              data-a-nofollow="true"
                            >
                              点击查看
                            </span>
                            <img src={icon_right} alt="" />
                          </div>
                        </div>
                        <div className={styles.pconsultationListBon}>
                          <div className={styles.pconsultationListBonLeft}>
                            <div
                              className={styles.pconsultationListBonLeftText1}
                            >
                              <h3>总交流次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount +
                                  itme?.contentDiags[0]?.patientExchangeCount ||
                                  0}
                              </h5>
                            </div>
                            <div
                              className={styles.pconsultationListBonLeftLine}
                            />
                            <div
                              className={styles.pconsultationListBonLeftText2}
                            >
                              <h3>医生回复次数</h3>
                              <h5>
                                {itme?.contentDiags[0]?.doctorExchangeCount ||
                                  0}
                              </h5>
                            </div>
                          </div>
                          <div className={styles.pconsultationListBonInfo}>
                            <span>患者：</span>
                            <h4>
                              {itme?.contentDiags[0]?.patientSex == 1
                                ? "男 "
                                : "女 "}
                              {itme?.contentDiags[0]?.patientAge || 0}
                            </h4>
                          </div>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              )}    
               {/* 展开更多 */}
              <div className={styles.pconsultationListMore}>
                <p
                  onClick={() => {
                    if (idnexID < 9) {
                      setIdnexID(10);
                    }
                  }}
                >
                  {contentDiagData &&
                  contentDiagData.length > 2 &&
                  idnexID < 9 ? (
                    <>
                      <span>展开更多</span>
                      <img src={evaluate5} alt="" />
                    </>
                  ) : null}
                </p>
              </div>
            </div>
          );
}

export default PatientConsultation;